import { useMemo } from 'react';
import { Cell, PieChart, Pie, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { CategoryBucket } from '@/api/analytics';

interface Props {
  data: CategoryBucket[];
}

const FALLBACK_COLORS = ['#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

export function CategoryDonut({ data }: Props) {
  const formatted = useMemo(
    () =>
      data.map((b, idx) => ({
        name: b.name,
        value: b.count,
        color: b.color ?? FALLBACK_COLORS[idx % FALLBACK_COLORS.length],
      })),
    [data]
  );

  if (formatted.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-sm text-slate-500">
        No records yet.
      </div>
    );
  }

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={formatted}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={2}
          >
            {formatted.map((entry, idx) => (
              <Cell key={idx} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: '1px solid rgba(148,163,184,0.3)',
              fontSize: 12,
            }}
          />
          <Legend
            iconType="circle"
            wrapperStyle={{ fontSize: 11 }}
            verticalAlign="bottom"
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
